import { ReactElement } from 'react'

import { BalanceSideProvider } from '@features/balanceLedger'
import { BalanceSide } from '@features/balanceLedger/enums/balanceSide'
import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { TransactionViewTrackingContext } from '@features/transactions/enums/transactionViewTrackingContext'
// TODO(AUDIT-255): cross-view import until balance ledger UI is extracted into the feature.
import { SuppliersBalanceDetailViewContent } from '@views/suppliersBalance/routes/SuppliersBalanceDetailView/SuppliersBalanceDetailView'

export const CustomersBalanceDetailView = (): ReactElement => (
  <BalanceSideProvider side={BalanceSide.Customer}>
    <TransactionViewProvider trackingContext={TransactionViewTrackingContext.CustomersBalance}>
      <SuppliersBalanceDetailViewContent />
    </TransactionViewProvider>
  </BalanceSideProvider>
)
